import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getBikeType } from './bikeThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearBikeKey } from '../../sell/sellKeys';
const SLICE_NAME = 'type';

const typeSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearBikeType(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getBikeType }).addCase(
            clearBikeKey,
            () => commonInitialState,
        );
    },
});

export const { clearBikeType } = typeSlice.actions;

export const type = typeSlice.reducer;
